const GTM_SCRIPT_ID = "gtm-script";
const TIKTOK_SCRIPT_ID = "tiktok-pixel";

declare global {
  interface Window {
    dataLayer?: Array<Record<string, unknown>>;
    ttq?: {
      track: (event: string, properties?: Record<string, unknown>) => void;
    };
  }
}

const ensureDataLayer = () => {
  if (typeof window === "undefined") {
    return;
  }
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
};

const injectGtmScript = (gtmId: string) => {
  if (typeof document === "undefined") {
    return;
  }
  if (document.getElementById(GTM_SCRIPT_ID)) {
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${encodeURIComponent(
    gtmId
  )}`;
  script.id = GTM_SCRIPT_ID;
  document.head.appendChild(script);
};

const injectTikTokPixel = (pixelId: string) => {
  if (typeof document === "undefined") {
    return;
  }
  if (document.getElementById(TIKTOK_SCRIPT_ID)) {
    return;
  }

  const script = document.createElement("script");
  script.id = TIKTOK_SCRIPT_ID;
  script.innerHTML = `
    !function (w, d, t) {
      w.TiktokAnalyticsObject=t;var ttq=w[t]=w[t]||[];
      ttq.methods=["page","track","identify","instances","debug","on","off","once","ready","alias","group","enableCookieStorage"],
      ttq.setAndDeployerConfig=function(e,n){ttq.__configs=ttq.__configs||{},ttq.__configs[n]=e},
      ttq.instance=function(e){e=e||"DEFAULT",ttq.__instance=ttq.__instance||{},ttq.__instance[e]=ttq.__instance[e]||{},
      ttq.__configs[e]=ttq.__configs[e]||{lib:d,v:t,instance:e}; var i=new ttq.__instance[e].constructor();return i};
      for(var o=0;o<ttq.methods.length;o++)ttq[ttq.methods[o]]=function(e){return function(){ttq.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(ttq.methods[o]);
    }(window, document, 'ttq');
    ttq.instance('DefaultPixel').track('PageView');
  `;
  document.head.appendChild(script);

  const tiktokPixelScript = document.createElement("script");
  tiktokPixelScript.async = true;
  tiktokPixelScript.src = `https://analytics.tiktok.com/i18n/pixel/events.js?pixel_id=${encodeURIComponent(pixelId)}`;
  document.head.appendChild(tiktokPixelScript);
};

export const initTracking = () => {
  if (typeof window === "undefined") {
    return;
  }

  const gtmId = process.env.REACT_APP_GTM_ID;
  const tiktokPixelId = process.env.REACT_APP_TIKTOK_PIXEL_ID;

  if (tiktokPixelId) {
    injectTikTokPixel(tiktokPixelId);
  } else if (gtmId) {
    ensureDataLayer();
    window.dataLayer!.push({
      "gtm.start": Date.now(),
      event: "gtm.js",
    });
    injectGtmScript(gtmId);
  }
};

export const trackEvent = (
  eventName: string,
  properties?: Record<string, unknown>
) => {
  if (typeof window === "undefined") {
    return;
  }

  const tiktokPixelId = process.env.REACT_APP_TIKTOK_PIXEL_ID;
  const gtmId = process.env.REACT_APP_GTM_ID;

  if (tiktokPixelId && window.ttq) {
    window.ttq.track(eventName, properties);
  } else if (gtmId) {
    ensureDataLayer();
    window.dataLayer!.push({
      event: eventName,
      ...properties,
    });
  }
};

export const pushToDataLayer = (payload: Record<string, unknown>) => {
  if (typeof window === "undefined") {
    return;
  }
  ensureDataLayer();
  window.dataLayer!.push(payload);
};
